import React from 'react'

import './AsyncSelectField.css'
import { createSelectOptions } from './AsyncSelectField.utils'

// queries
import { useQuery } from '@apollo/client'

// mui
import { Autocomplete, TextField } from '@mui/material'

export default function AsyncSelectField({ placeholder, onChange, query, value = "", grouped = false, disabled = false, showRequired = true, required = true, isValid = true }) {

    let options = []

    // use apolloClient
    const { loading, error, data } = useQuery(query.query, {
        variables: query.variables ? {...query.variables} : {}
    })
    if(data) {
        options = createSelectOptions(query.rules, data)
    }

    const defaultValue = (options, value) => {
        return options ? options.find(option => option.id == value) : ""
    }

    const handleChange = (_, newValue) => {
        onChange({...newValue, value: newValue ? newValue.id : "" })
    }

    return (
        <Autocomplete 
            value={defaultValue(options, value) || null}
            groupBy={grouped ? (option) => option.group : null}
            options={options}
            loading={loading}
            onChange={handleChange}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option ? option.label : ''}
            disabled={disabled}
            renderInput={(params) => (
                <TextField 
                    {...params}
                    label={placeholder}
                    required={required}
                    error={!isValid}
                    helperText={!isValid ? 'Please enter a valid value' : ''}
                    sx={{ marginBottom: 2}}
                />
            )}
        />)
}